import { Stack, styled } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';

const Layout = () => {
  return (
    <LayoutContainer>
      <AppHeader />
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
    </LayoutContainer>
  );
};

const LayoutContainer = styled(Stack)({
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
});

const ContentWrapper = styled(Stack)({
  position: 'relative',
  flex: 1,
  width: '100%',
  overflowY: 'auto',
});

export default Layout;
